module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAQRJREFUeAHtlsERgjAQRX8Y+5BOSAfiST2BHdiBWIElgCfwBHSApVhJTGa8SMBs0KiMvAPDMJ/dP9mfTICJf4dpX8rcB2OpfOMYVJElWKwOVLmnF/COg5srhEhQn/dUuddRIcSrWJjw4AqiCXcGiCZmoJHJYheDhssARug2gb5g0gyo5stN9lRT5uoZ9fzfa8LtCHQT2jj0c6AqBFwSrh96fm4FeqCGsJFLeIUNjM1BONCoITwZQ9imzGNpgptkIxmB2t9VEcAOnyKiZoDDESMZgRDbgSFMTbLRhDC4n/U2cIqIGkK1nDEc8PUR/KSBBq4QoobRgNpyAjXe31zdqHaYmGhxA9JmUlB938OaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/templateMessage.png
// module id = U9jk
// module chunks = 1